// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__t5cQN","frameSquare":"recentes_frameSquare__yzynL","imagem":"recentes_imagem__ILhi3","marca":"recentes_marca__ECJMN","modelo":"recentes_modelo__HK8Tr"};